import React, { Component } from 'react';
import { Dimmer, Loader, Grid } from 'semantic-ui-react'
import FormatCurrency from "../FormatCurrency"
import { changeFontColor } from "../../shared/helpers/styles";

export default class BudgetHeader extends Component {

    render() {
        const PageLoader = () => (
            <Dimmer active={this.props.showLoader} inverted>
                <Loader size='medium'>Loading Budget Summary ...</Loader>
            </Dimmer>
        );

        return (
            <div>
                <PageLoader />
                <Grid>
                    <Grid.Row className='grid-padding'>
                        <Grid.Column width={2} />
                        <Grid.Column width={5} textAlign='center'>
                            <b>Total Income</b>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <b>Total Expenses</b>
                        </Grid.Column>
                        <Grid.Column width={4} textAlign='center'>
                            <b>Cash Flow</b>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row className='grid-padding'>
                        <Grid.Column width={2} textAlign='center'>
                            <b>Projected</b>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.incomes_total_projected)}>
                                <FormatCurrency amount={this.props.incomes_total_projected} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.expenses_total_projected)}>
                                <FormatCurrency amount={this.props.expenses_total_projected} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={4} textAlign='center'>
                            <div className={changeFontColor(this.props.cash_flow_projected)}>
                                <FormatCurrency amount={this.props.cash_flow_projected} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row className='grid-padding'>
                        <Grid.Column width={2} textAlign='center'>
                            <b>Actual</b>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.incomes_total)}>
                                <FormatCurrency amount={this.props.incomes_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.expenses_total)}>
                                <FormatCurrency amount={this.props.expenses_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={4} textAlign='center'>
                            <div className={changeFontColor(this.props.cash_flow)}>
                                <FormatCurrency amount={this.props.cash_flow} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row className='grid-padding'>
                        <Grid.Column width={2} textAlign='center'>
                            <b>Previous Month</b>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.previous_month_incomes_total)}>
                                <FormatCurrency amount={this.props.previous_month_incomes_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.previous_month_expenses_total)}>
                                <FormatCurrency amount={this.props.previous_month_expenses_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={4} textAlign='center'>
                            <div className={changeFontColor(this.props.previous_month_cash_flow)}>
                                <FormatCurrency amount={this.props.previous_month_cash_flow} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row className='grid-padding'>
                        <Grid.Column width={2} textAlign='center'>
                            <b>3 Month Average</b>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.three_month_avg_incomes_total)}>
                                <FormatCurrency amount={this.props.three_month_avg_incomes_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div className={changeFontColor(this.props.three_month_avg_expenses_total)}>
                                <FormatCurrency amount={this.props.three_month_avg_expenses_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={4} textAlign='center'>
                            <div className={changeFontColor(this.props.three_month_avg_cash_flow)}>
                                <FormatCurrency amount={this.props.three_month_avg_cash_flow} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BudgetHeaderMonthly/index.js